import { render, staticRenderFns } from "./TablePageHeader.vue?vue&type=template&id=5d6b5eaf&scoped=true&"
import script from "./TablePageHeader.vue?vue&type=script&lang=js&"
export * from "./TablePageHeader.vue?vue&type=script&lang=js&"
import style0 from "./TablePageHeader.vue?vue&type=style&index=0&id=5d6b5eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b5eaf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
